import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const scoreCardFilterSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getStartDateOverrides: builder.query({
            query: (arg: any) => {
                const { employeenumber, scorecardVersionId } = arg;
                return {
                    url: constants.START_DATE_OVERRIDE_EXCEPTIONS,
                    params: { employeenumber, scorecardVersionId },
                };
            },
            providesTags: ['ScStartDateOverride'],
        }),
        createStartDateOverride: builder.mutation({
            query: (arg: any) => ({
                url: constants.START_DATE_OVERRIDE_CREATE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['ScStartDateOverride'],
        }),
        deleteStartDateOverrides: builder.mutation({
            
            query: (arg: any) => ({
               
                url: constants.DELETE_START_DATE_OVERRIDE_EXCEPTIONS,
                method: 'PUT',
                body: arg.scorecardId,
                params: { oracleIDs: arg.oracleIDs},
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),

            invalidatesTags: ['ScStartDateOverride'],
        }),

    }),
});

export const {
    useCreateStartDateOverrideMutation,
    useDeleteStartDateOverridesMutation,
    useGetStartDateOverridesQuery,
}=scoreCardFilterSlice